module.exports = __webpack_public_path__ + "img/technology12.989cc12d.png";